import * as aTypes from '../../action-types'
import * as mTypes from '../../mutation-types'
import api from '../../../api'
import { mapFormItem, perPageItem } from '../../../utils'

import feedback from './feedback'
import feedbackDetail from './feedbackDetail'

/*
const sampleList = [{
  id: 'something',
  name: '羊宝宝和小兔兔的展览报名',
  value: 111,
  update: '今天 16:50'
}, {
  id: 'something',
  name: '羊宝宝和小兔兔的展览报名',
  value: 456,
  update: '今天 16:50'
}, {
  id: 'something',
  name: '羊宝宝和小兔兔的展览报名羊宝宝和小兔兔的展览报名',
  value: 789,
  update: '今天 16:50'
}, {
  id: 'something',
  name: '羊宝宝和小兔兔的展览报名',
  value: 123,
  update: '今天 16:50'
}]
*/

const state = {
  list: [],
  currentPage: 1,
  hasMore: true
}

const actions = {
  [aTypes.FORM_GET_LIST] ({ commit }, { page, append }) {
    commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_LIST, loading: true })
    api.form.getList({
      success (res) {
        const list = res.body.data.map(mapFormItem)
        const pagination = res.body.meta.pagination
        const hasMore = pagination.current_page < pagination.total_page
        commit(mTypes.FORM_SET_LIST, { list, page, hasMore, append })
        commit(mTypes.SET_LOADED_OF_FORM_LIST, true)
        commit(mTypes.SET_LOADING, { key: aTypes.FORM_GET_LIST, loading: false })
      },
      commit
    }, { page, perPage: perPageItem })
  }
}

const mutations = {
  [mTypes.FORM_SET_LIST] (state, { list, page, hasMore, append }) {
    if (append) {
      state.list = state.list.concat(list)
    } else {
      state.list = list
    }
    state.currentPage = page
    state.hasMore = hasMore
  }
}

export default {
  modules: {
    feedback,
    feedbackDetail
  },
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/form/index.js